(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tapanda-discount-tab"] && !Shopify.designMode) return;
  try {
    (function () {
    var tab = document.querySelector('[data-tapanda-discount-tab]');
    if (!tab || tab.getAttribute('data-tapanda-discount-tab-ready') === 'true') return;
    tab.setAttribute('data-tapanda-discount-tab-ready', 'true');

    /* ── Telefon: zakładka wysuwa się po chwili i po chwili chowa ──
       Na komputerze wisi cały czas (CSS), tu byłaby natrętna na wąskim ekranie.
       POKAZ_PO   — ile czekamy, zanim wyjedzie (użytkownik zdąży się rozejrzeć)
       WIDOCZNA   — jak długo zostaje na ekranie
       PRZERWA    — po zamknięciu/pokazaniu nie wraca przez ten czas w tej sesji */
    var POKAZ_PO = 12000;
    var WIDOCZNA = 9000;
    var KLUCZ = 'tp_tab_peeked';
    var waskiEkran = window.matchMedia('(max-width: 989px)');

    function juzPokazana() {
      try { return sessionStorage.getItem(KLUCZ) === '1'; } catch (e) { return false; }
    }
    function zapamietaj() {
      try { sessionStorage.setItem(KLUCZ, '1'); } catch (e) {}
    }

    if (waskiEkran.matches && !juzPokazana()) {
      window.setTimeout(function () {
        if (document.hidden) return;
        /* nie wchodzimy w drogę otwartemu oknu newslettera */
        if (document.body.classList.contains('tp-np-drawer-open')) return;
        var popup = document.getElementById('tp-newsletter-popup');
        if (popup && !popup.hidden) return;

        tab.classList.add('is-peeking');
        zapamietaj();

        window.setTimeout(function () {
          if (!document.body.classList.contains('tp-np-drawer-open')) {
            tab.classList.remove('is-peeking');
          }
        }, WIDOCZNA);
      }, POKAZ_PO);
    }
    tab.addEventListener('click', function () {
      /* Klik w wysuniętą zakładkę kończy jej pokaz — bez tego klasa is-peeking
         zostawała na stałe i zakładka wisiała do końca sesji. */
      tab.classList.remove('is-peeking');
      document.dispatchEvent(new CustomEvent('tapanda:newsletter:open', {
        detail: { trigger: tab }
      }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
